import Vue from 'vue';

function ensureAnchorId(anchor?: string) {
    return anchor ? anchor.startsWith('#') ? anchor.slice(1) : anchor : undefined;
}

Vue.filter('anchor', ensureAnchorId);

export default ensureAnchorId;
